import React, { useState, useContext, useEffect } from 'react';
import {IProps, UpperCase} from './types';
import Tooltip from '@components/Tooltip';
import * as S from './styles';
import { Context } from "routes/private/Editor/Context";
import { findCommonAttributeValue } from '@utils/editor'
import {ReactComponent as UppercaseIcon} from 'assets/svgs/AA.svg';

const FontUppercaseComandOption:React.FC<IProps> = (props) => {      
  let context = useContext(Context);
  const [isSelected, setIsSelected]= useState(false);

  useEffect(() => {
    const fontUpperCase = findCommonAttributeValue(context.editorStatus.selectedElementsId, context.data, "fontUpperCase", "Text", context.editorStatus.textSelectionInformation);
    setIsSelected(fontUpperCase===undefined?false:parseInt(fontUpperCase.toString())===UpperCase.allcaps);
  }, [context.editorStatus.selectedElementsId.length, context.editorStatus.selectedElementsId[0], context.data, context.editorStatus.textSelectionInformation]);

  const SetFontUppercase = () => {          
    setIsSelected(!isSelected);        
    context.onCommandChange("fontUpperCase", !isSelected?UpperCase.allcaps:UpperCase.none);
  }

  return (
    <S.Root>
         <Tooltip tip={"Uppercase"}>
        <S.ButtonContainer onClick={SetFontUppercase} isSelected={isSelected}>       
            <UppercaseIcon/>        
        </S.ButtonContainer>
        </Tooltip>
    </S.Root>
  );

}


export default FontUppercaseComandOption;